// src/api/api.js
// CRA proxy mode: use relative URLs like "/api/v1/...."

const normalizePath = (path) => {
  if (!path) return "/";
  if (/^https?:\/\//i.test(path)) return path;
  return path.startsWith("/") ? path : `/${path}`;
};

export async function apiFetch(path, options = {}) {
  const url = normalizePath(path);

  const headers = { ...(options.headers || {}) };
  try {
    const token = localStorage.getItem("etf_token");
    if (token && !headers.etftoken) headers.etftoken = token;
  } catch (_) {}

  const hasBody = options.body !== undefined && options.body !== null;
  const isFormData =
    typeof FormData !== "undefined" && options.body instanceof FormData;

  if (hasBody && !isFormData) headers["Content-Type"] = "application/json";

  let res;
  try {
    res = await fetch(url, { ...options, headers });
  } catch {
    throw new Error("Network error: API not reachable");
  }

  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { message: text };
  }

  if (!res.ok) throw new Error(data?.message || `Request failed (${res.status})`);
  return data;
}
